import * as React from 'react';
import { classes } from '../../helpers';
import { elevationCss } from '../../helpers/elevations';
import { Portal } from '../Popover/Portal';
import { useTheme } from '../Theme/Theme';
import { style } from './style';
export const Drawer = (props) => {
    var _a, _b, _c, _d;
    const { elevation = 24, onClose = () => ({}) } = props;
    if (!props.isVisible) {
        return null;
    }
    const [className, updateClassName] = React.useState('');
    const theme = useTheme();
    const css = style(theme);
    const beforeClose = () => {
        setTimeout(onClose, 200);
        updateClassName(css[`slideOut${props.placement.charAt(0).toUpperCase() + props.placement.slice(1)}` || 'slideOutRight']);
    };
    return (React.createElement(Portal, null,
        React.createElement(React.Fragment, null,
            React.createElement("div", { className: css.maskStyle, onClick: () => props.onClose && beforeClose() }),
            React.createElement("div", { style: (_a = props.style) === null || _a === void 0 ? void 0 : _a.container, className: classes(css.drawerStyle, css[`slideIn${props.placement.charAt(0).toUpperCase() + props.placement.slice(1)}` || 'slideInRight'], elevationCss(elevation), className) },
                props.header && (React.createElement("div", { style: (_b = props.style) === null || _b === void 0 ? void 0 : _b.header, className: "header" }, props.header)),
                React.createElement("div", { style: (_c = props.style) === null || _c === void 0 ? void 0 : _c.body, className: "body" }, props.children),
                props.footer && (React.createElement("div", { style: (_d = props.style) === null || _d === void 0 ? void 0 : _d.footer, className: "footer" }, props.footer))))));
};
Drawer.defaultProps = {
    placement: 'right',
    style: {},
};
//# sourceMappingURL=Drawer.js.map